import { isValidUsername } from '$lib/utils/username'
import type { ParamMatcher } from '@sveltejs/kit'

export const match: ParamMatcher = (param) => {
  // Normal username or user id
  return isValidUsername(param, { maxLength: 40 })
}
